import { LegalLayout } from "./LegalLayout";

export function TokushohoPage() {
  return (
    <LegalLayout title="特定商取引法に基づく表記">
      <p className="text-white/50 text-sm">最終更新日: 2026年2月18日</p>

      <dl className="mt-8 divide-y divide-white/10">
        <div className="py-4">
          <dt className="font-semibold text-white">販売・管理事業主名</dt>
          <dd className="mt-1 text-on-surface-variant">株式会社WakeApp 黒田 裕己</dd>
        </div>
        <div className="py-4">
          <dt className="font-semibold text-white">本社所在地</dt>
          <dd className="mt-1 text-on-surface-variant">東京都渋谷区上原2-35-8</dd>
        </div>
        <div className="py-4">
          <dt className="font-semibold text-white">問い合わせ窓口</dt>
          <dd className="mt-1 text-on-surface-variant">お問い合わせフォームからお願いします</dd>
        </div>
        <div className="py-4">
          <dt className="font-semibold text-white">事業者のその他連絡先</dt>
          <dd className="mt-1 text-on-surface-variant">
            電話番号開示を希望される場合はメールでご連絡いただければ遅延なく開示いたします。
          </dd>
        </div>
        <div className="py-4">
          <dt className="font-semibold text-white">商品代金以外の必要料金</dt>
          <dd className="mt-1 text-on-surface-variant">なし</dd>
        </div>
        <div className="py-4">
          <dt className="font-semibold text-white">お支払い方法</dt>
          <dd className="mt-1 text-on-surface-variant">
            クレジットカード（VISA / MasterCard / JCB / American Express / Diners）
          </dd>
        </div>
        <div className="py-4">
          <dt className="font-semibold text-white">代金の支払い時期</dt>
          <dd className="mt-1 text-on-surface-variant">クレジットカード決済：購入時</dd>
        </div>
        <div className="py-4">
          <dt className="font-semibold text-white">返品・交換不良品について</dt>
          <dd className="mt-1 text-on-surface-variant">
            原則としてサービス導入後のキャンセルは不可
          </dd>
        </div>
        <div className="py-4">
          <dt className="font-semibold text-white">商品の引渡し時期</dt>
          <dd className="mt-1 text-on-surface-variant">
            お支払い手続き完了後、直ちにご利用いただけます
          </dd>
        </div>
        <div className="py-4">
          <dt className="font-semibold text-white">解約の対応方法</dt>
          <dd className="mt-1 text-on-surface-variant">
            解約につきましては、管理画面またはお問い合わせフォームにてご連絡ください。その後、担当よりご連絡させていただきます。解約申し出があった課金期間の末日をもって解約となります。なお、日割り分等での返金は承っておりませんのでご了承ください。
          </dd>
        </div>
      </dl>
    </LegalLayout>
  );
}
